import React from 'react';
import emailjs from 'emailjs-com';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import './ContactDetail.css';


const ContactDetail = () => {

    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('gmail', 'template_djl8c1f', e.target, 'user_WovdxbrWdNZ9zguEgQF92')
          .then((result) => {
              if(result){
                  e.target.reset();
                  alert("Your Message Send Successfully");
                  console.log(result.text);
              }
          }, (error) => {
              console.log(error.text);
          });
      }
    return (
        <div className="container-fluid c_detail">
            <div className="text-center mb-4">
                <h1>Contact me</h1>
                <span className="g_touch">get in touch</span>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <h5>Get in Touch</h5>
                    <p className="p">Although I'm not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!</p>
                    <ul className="c_group">
                        <li className="row align-items-center mb-1">
                            <div className="col-md-1">
                                <FontAwesomeIcon className="brand-icon" icon={faUser} />
                            </div>
                            <div className="col-md-6">
                                <p className="m-0">Name</p>
                                <small className="text-secondary">Mr Riaz</small>
                            </div>
                        </li>
                        <li className="row align-items-center mb-1">
                            <div className="col-md-1">
                                <FontAwesomeIcon className="brand-icon" icon={faMapMarkerAlt} />
                            </div>
                            <div className="col-md-6">
                                <p className="m-0">Address</p>
                                <small className="text-secondary">Dhaka, Bangladesh</small>
                            </div>
                        </li>
                        <li className="row align-items-center mb-1">
                            <div className="col-md-1">
                                <FontAwesomeIcon className="brand-icon" icon={faEnvelope} />
                            </div>
                            <div className="col-md-6">
                                <p className="m-0">Email</p>
                                <small className="text-secondary">monsur.riaz1@gmail.com</small>
                            </div>
                        </li>
                    </ul>
                </div>
                <form className="form-group col-md-6" onSubmit={sendEmail}>
                    <h5>Have a question or want to work together?</h5>
                    <div className="row">
                        <div className="col-6 form-group pt-2">
                            <input type="text" className="form-control" placeholder="Full Name" name="name" />
                        </div>
                        <div className="col-6 form-group pt-2">
                            <input type="email" className="form-control" placeholder="Email" name="email" required />
                        </div>
                        <div className="col-12 form-group pt-2">
                            <input type="text" className="form-control" placeholder="Subject" name="subject" required />
                        </div>
                        <div className="col-12 form-group pt-2">
                            <textarea rows="4" type="text" className="form-control" placeholder="Message" name="message" required />
                        </div>
                        <div className="col-4 form-group pt-2">
                            <input className="btn" type="submit" value="Submit" />
                            {/* <button className="btn bg-transparent" type="submit">Submit</button> */}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContactDetail;